/**
 * This patch fixes corrupt detailPage filters that have a non-existing collection id in their `detailPage` filter.
 */

import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import _ from 'lodash';
import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {
      jsonNode: {data: nodeData = {}, _id},
    },
    extraContext: {collections},
  } = context;

  const hasDataWHrefBinding = DomTypeUtils.isDynBound(nodeData, 'dataWHref');
  const lastBindingPathFragment: any =
    hasDataWHrefBinding && Array.isArray(nodeData.dyn.bind.dataWHref)
      ? _.last(nodeData.dyn.bind.dataWHref)
      : null;
  const boundFieldId = lastBindingPathFragment
    ? lastBindingPathFragment.id
    : null;
  const filter = lastBindingPathFragment && lastBindingPathFragment.filter;
  const filterParts = typeof filter === 'string' && filter.split('|');
  const filterName = filterParts && filterParts[0];
  const collectionId = filterParts && filterParts[1];
  const primaryLookupCollection =
    collections && collectionId && collections[collectionId];
  // If primaryLookupCollection is not found, it means the link is corrupted and we need
  // to apply the patch. We are able to patch the collection id, if we are able to find
  // a collection that has the slug field used in the binding.

  const fallbackLookupCollection =
    filterName === 'detailPage' &&
    boundFieldId != null &&
    !primaryLookupCollection &&
    collections
      ? _.find(
          collections,
          (coll) =>
            coll &&
            coll.fields &&
            coll.fields.some(
              (field) =>
                field && field.slug === 'slug' && field.id === boundFieldId
            )
        )
      : null;

  return {
    needed: fallbackLookupCollection != null,
    logData: {
      msg: 'dataWHref-bound link has a corrupt detailPage filter',
      meta: {
        nodeId: _id,
      },
    },
    apply: () => {
      // These are already checked in `needed` above but we need these for Flow type check to pass.
      if (
        fallbackLookupCollection &&
        fallbackLookupCollection._id &&
        lastBindingPathFragment
      ) {
        const newFilter = `detailPage|${fallbackLookupCollection._id}`;
        lastBindingPathFragment.filter = newFilter;
      }
    },
  };
};
